export default () => ({
   /** Global **/
   clientId: 0,
   verticalId: 100,
   currentUser: {},

   templates: [],
   channelOptions: {},
   categoryOptions: {},
   isLoadingChannels: false,
   isLoadingCategories: false,

   /**Media Picker **/
   mediaPickerOpen: false,
   mpChannels: [],
   mpChannelRecid: -1,
   draggingAssetRecid: -1,
   draggingAssetType: 0,
   selectedAssets: [],
   assignedAsset: -1,
   mpAssetType: -1,
   mpActiveId: -1,
   mpCurrActiveAssetRecid: -1,
   mpMultiSelect: false,


   mpRecentAssets: [],
   mpRecentPage: 0,
   isLoadingRecent: false,
   recentMore: false,

   mpActiveAssets: [],
   mpActivePage: 0,
   isLoadingActive: false,
   activeMore: false,

   currSelectedAssetType: 1,
   currSelectedCategory: '',
   currSearchTerm: '',

   isScoreboard: false,

   /* Modals */
   modalError: false,
   modalSubheadText: '',
   modalHeaderText: '',
   modalMessage: '',
   modalList: [],
   notifyModal: false,
   actionModal: false,
   deleteConfirmModal: false,
   modalActionType: '',

   unsavedChangesModal: false,





   /* UPLOAD */
   currentStatus: 0,
   invalidExtFiles: [], //files that cannot be uploaded due to an extension bard does not except
   toBeUploadedFiles: [], //files that we will attempt to upload
   uploadErrorFiles: [], //files that had valid extensions but couldn't be uploaded for some reason
   uploadedFiles: [], //files that were successfully uploaded
   successFiles: [], //files that were successfully uploaded and ingested
   ingestedRecids: [], //recids of files that were ingested successfully
   uploadProgress: 0,
   uploadTotal: 0,




   /* Smart Canvas Overlay */
   scOverlayOpen: false,
   instanceRecid: -1,
   
});